import { render } from "./RolesView.vue?vue&type=template&id=603b149f"
import script from "./RolesView.vue?vue&type=script&lang=js"
export * from "./RolesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__